// Routes configuration for BASIC project
import React from 'react'
import SmartRedirect from '../../components/SmartRedirect/SmartRedirect'
import { LazyStores } from '../shared/heavyRouteChunks'

/**
 * Get project-specific routes for BASIC
 * @param {object} options - Route options
 * @param {object} options.state - Redux state
 * @param {string} options.openProjectName - Current project name
 * @returns {Array} Array of route configurations
 */
export const getBASICRoutes = ({ state, openProjectName }) => {
	return [
		{
			path: '/integrations',
			element: <LazyStores />,
			// No conditions - always available
		},
		{
			path: '/payments/subscription_bin_success/',
			element: <SmartRedirect />,
			// Payment success route
		},
		{
			path: '/api/payments/subscription_bin_success/',
			element: <SmartRedirect />,
			// Payment success route (API)
		},
		{
			path: '*',
			element: <SmartRedirect />,
			// Catch-all route
		}
	]
}
